import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { getCurrentDateTime } from '@/utils/getCurrentDateTime';
import { Schedule, TableFilters } from '../types';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import ScheduleItem from './ScheduleItem/ScheduleItem';
import Button from '../../Button/Button';
import styles from './ScheduleTableMobile.module.scss';
import MobileFilters from './MobileFilters/MobileFilters';

type ScheduleTableMobileProps = {
  data?: Schedule[];
  isLoading: boolean;
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
  clearFilters: () => void;
  showDetail?: boolean;
};

const countActiveFilters = (filters: TableFilters) => {
  return Object.values(filters).reduce((count, value) => {
    return count + (value ? 1 : 0);
  }, 0);
};

const ScheduleTableMobile: FC<ScheduleTableMobileProps> = ({
  data,
  isLoading,
  filters,
  setFilters,
  clearFilters,
  showDetail,
}) => {
  const { t } = useTranslation('schedule');
  const [showFilters, setShowFilters] = useState(false);

  const scheduleItems =
    !data || !data.length ? (
      <p className={styles.noData}>{t('noData')}</p>
    ) : (
      data?.map((item) => (
        <ScheduleItem
          key={item.codigo}
          codigo={item.codigo}
          nombre={item.nombre}
          servicio={item.servicio}
          comienzoOperaciones={item.comienzoOperaciones}
          finOperaciones={item.finOperaciones}
          aperturaStacking={item.aperturaStacking}
          cierreStacking={item.cierreStacking}
          cutOff={item.cutOff}
          fechaFinDescarga={item.fechaFinDescarga}
          showDetail={showDetail}
        />
      ))
    );

  const lastUpdate = getCurrentDateTime();

  const activeFiltersCount = countActiveFilters(filters);
  const activeFiltersCountText =
    activeFiltersCount > 0 ? `(${activeFiltersCount})` : '';

  return (
    <div className={styles.scheduleTableMobile}>
      <header>
        <Button secondary onClick={() => setShowFilters(true)}>
          <FontAwesomeIcon icon={faFilter} className={styles.filterIcon} />
          {t('filtersButton')}&nbsp;
          {activeFiltersCountText}
        </Button>
        <div className={styles.lastUpdate}>
          <p>{t('lastUpdate')}*:</p>
          <p>{lastUpdate}</p>
        </div>
      </header>
      {isLoading ? <LoadingSpinner /> : scheduleItems}
      <MobileFilters
        isOpen={showFilters}
        close={() => setShowFilters(false)}
        filters={filters}
        setFilters={setFilters}
        clearFilters={clearFilters}
      />
    </div>
  );
};

export default ScheduleTableMobile;
